import VideoTitle from "./VideoTitle";
import AuthorBox from "./AuthorBox";
import VideoDescription from "./VideoDescription";
import CommentBox from "./CommentBox";
import { useState, useContext, useEffect } from "react";
import { campaignFetcher, subscribersFetcher } from "../../api/requests";
import { useToaster } from "../../context/toaster";
import { ProfileContext } from "../../context/profile";
import { useLocation, useHistory } from "react-router-dom";
import { AuthContext } from "../../context/auth";

const SingleVideoLeft = ({ video }) => {
  const [subscribed, setSubscribed] = useState(false);
  const [subscription, setSubscription] = useState();
  const { addMessage } = useToaster();
  const { profile } = useContext(ProfileContext);
  const location = useLocation();
  const campaignId = new URLSearchParams(location.search).get("campaign");
  const { user } = useContext(AuthContext);
  const history = useHistory();
  const [subscribeLoading, setSubscribeLoading] = useState(false);

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubscribe = async () => {
    if (!user.user_id) {
      history.push("/auth/login/");
      return;
    }

    try {
      if (subscribed) {
        if (subscription?.results?.length > 0) {
          const res = campaignId
            ? await campaignFetcher.unsubscribe(subscription.results[0].id)
            : await subscribersFetcher.unsubscribe(subscription.results[0].id);
          showToast("success", "لغو اشتراک با موفقیت انجام شد.");
          setSubscribed(false);
          setSubscription(null);
        }
      } else {
        const res = campaignId
          ? await campaignFetcher.subscribe(video?.campaign?.id)
          : await subscribersFetcher.subscribe(video?.channel?.id);
        if (res) {
          setSubscribeLoading(true);
          showToast("success", "با موفقیت عضو شدید.");
          setSubscribed(true);
          const updatedSubscriptionData = campaignId
            ? await campaignFetcher.isSubscribed(
                profile.user,
                video?.campaign.id
              )
            : await subscribersFetcher.isSubscribed(
                profile.user,
                video?.channel.id
              );
          setSubscription(updatedSubscriptionData);
        } else {
          setSubscribeLoading(false);
        }
      }
    } catch (error) {
      showToast(
        "error",
        Object.values(error.response?.data)[0] ??
          "خطایی رخ داده است، دوباره تلاش کنید."
      );
    }
  };

  useEffect(() => {
    const checkSubscription = async () => {
      if (profile.user && (video?.channel?.id || video?.campaign?.id)) {
        setSubscribeLoading(true);
        try {
          const subscriptionData = campaignId
            ? await campaignFetcher.isSubscribed(
                profile.user,
                video?.campaign.id
              )
            : await subscribersFetcher.isSubscribed(
                profile.user,
                video?.channel.id
              );
          setSubscribed(subscriptionData?.count > 0);
          setSubscription(subscriptionData);
        } catch (error) {
          console.error("Error checking subscription:", error);
          setSubscribed(false);
        } finally {
          setSubscribeLoading(false);
        }
      }
    };

    checkSubscription();
  }, [profile.user, video?.channel?.id, video?.campaign?.id]);

  return (
    <>
      <div className="single-video-left">
        <VideoTitle title={video?.title} views={video?.counted_views} />

        <AuthorBox
          subscriberCount={
            campaignId
              ? video?.campaign?.subscribe_count
              : video?.channel?.subscribe_count
          }
          imgSrc={campaignId ? video?.campaign.banner : video?.channel?.avatar}
          channelName={
            campaignId ? video?.campaign?.name : video?.channel?.name
          }
          publishedOn={video?.published_date}
          channelHref={`${
            campaignId
              ? `/single-channel/${video?.campaign.id}/?campaign=true`
              : `/single-channel/${video?.channel.id}`
          }`}
          isSubscribed={subscribed}
          SubscribeLoading={subscribeLoading}
          handleSubscribe={handleSubscribe}
        />

        <VideoDescription video={video} />

        <CommentBox />
      </div>
    </>
  );
};

export default SingleVideoLeft;
